<style lang="stylus" scoped>
@import '../css/var'
.title
  color $normal-text-color
  font-size pt(36)
  text-align center
</style>
<template>
  <div class="title">{{titleText}}</div>
</template>
<script>
export default {
  props: {
    titleText: ''
  }
}
</script>


// WEBPACK FOOTER //
// title-text.vue?b38d410e